function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useStripe } from '@stripe/react-stripe-js';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Wizard } from 'react-use-wizard';
import { MEMBERSHIP } from '../../../constants/membership';
import { alertWarning, assignPayment, refreshCustomer, sendLead, setMembershipPriceId, showModal, subscribe } from '../../../redux/actions';
import { isStaff, isUserUnderTrial } from '../../../utilities/user';
import MembershipManagementPaymentStep from './MembershipManagementPaymentStep';
import { isEmpty, noop } from 'lodash';
import { PAYMENT_FAILURE_MODAL } from '../../../components/modal/PaymentFailureModal';
import StripeElements from '../../../components/stripe/StripeElements';
import Breadcrumbs from '../../../components/wizard/Breadcrumbs';
import BreadcrumbStep from '../../../components/wizard/BreadcrumbStep';
import { LEAD_START_ESSENTIAL } from '../../../constants/job';
import { PAY_MODE } from '../../../constants/order';
import { useQuery } from '../../../hooks/useQuery';
import routes from '../../../routes/constants';
import text from '../../../text';
import ConfirmationStep from '../OrderWizard/ConfirmationStep';
import MembershipStep from '../OrderWizard/MembershipStep';
import { PaymentContext } from '../PaymentContext';
var isAssignedPayment = function(selectedPayMode) {
    return selectedPayMode === PAY_MODE.ASSIGNED_PAYMENT;
};
var MembershipManagementWizard = function() {
    var dispatch = useDispatch();
    var stripe = useStripe();
    var returnPage = routes.user.membershipManagement;
    var returnUrl = "".concat(process.env.LARKI_APP_URL).concat(returnPage);
    var queryParams = useQuery();
    var history = useHistory();
    var location = useLocation();
    var _useContext = useContext(PaymentContext), membershipStepper = _useContext.states.membershipStepper;
    var _useSelector = useSelector(function(state) {
        return {
            membershipPriceId: state.order.membershipPriceId,
            paymentMethodId: state.order.paymentMethodId,
            selectedPayMode: state.order.selectedPayMode,
            currentUser: state.profileReducer.userProfile,
            membershipPrices: state.profileReducer.membershipPrices,
            upsertMembership: state.profileReducer.upsertMembership
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId, selectedPayMode = _useSelector.selectedPayMode, paymentMethodId = _useSelector.paymentMethodId;
    var handleSendToPayer = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(payerName, payerEmail, message) {
            var nextStep;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nextStep = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : noop;
                        if (!isAssignedPayment(selectedPayMode)) {
                            nextStep();
                            return [
                                2
                            ];
                        }
                        // 'Send to Payer' payment selected
                        return [
                            4,
                            dispatch(assignPayment(membershipPriceId, undefined, payerEmail, payerName, message))
                        ];
                    case 1:
                        _state.sent();
                        history.push({
                            pathname: routes.payment.assignedStatus(),
                            state: {
                                payerEmail: payerEmail,
                                payerName: payerName,
                                isMembership: true
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendToPayer(payerName, payerEmail, message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _location_state, _newMembership_paymentIntent, redirectTo, _location_state1, newMembership, membershipResult;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        redirectTo = null;
                        if ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.redirectTo) {
                            ;
                            redirectTo = (_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1.redirectTo;
                        } else if (queryParams.get('redirectTo')) {
                            redirectTo = {
                                path: queryParams.get('redirectTo'),
                                label: queryParams.get('label')
                            };
                        }
                        return [
                            4,
                            dispatch(subscribe({
                                user: currentUser,
                                priceId: membershipPriceId,
                                paymentMethodId: paymentMethodId,
                                isTrial: false
                            }))
                        ];
                    case 1:
                        newMembership = _state.sent();
                        if (!(((_newMembership_paymentIntent = newMembership.paymentIntent) === null || _newMembership_paymentIntent === void 0 ? void 0 : _newMembership_paymentIntent.status) === 'requires_confirmation')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            stripe.confirmCardPayment(newMembership.payment_intent_secret, {
                                payment_method: paymentMethodId,
                                return_url: returnUrl
                            }, {
                                handleActions: false
                            })
                        ];
                    case 2:
                        membershipResult = _state.sent();
                        if (membershipResult === null || membershipResult === void 0 ? void 0 : membershipResult.error) {
                            console.error(membershipResult.error);
                            dispatch(showModal(PAYMENT_FAILURE_MODAL, {
                                message: text('membershipPaymentFailed')
                            }));
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            dispatch(refreshCustomer())
                        ];
                    case 4:
                        _state.sent();
                        dispatch(sendLead(null, LEAD_START_ESSENTIAL));
                        history.push(_object_spread({
                            pathname: routes.user.membershipChangeSuccess
                        }, !isEmpty(redirectTo) && {
                            state: {
                                redirectTo: redirectTo
                            }
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        if (isUserUnderTrial(currentUser)) {
            dispatch(setMembershipPriceId(MEMBERSHIP.MONTHLY.PRICE_ID));
        }
    }, [
        currentUser,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "MembershipManagementWizard"
    }, /*#__PURE__*/ React.createElement(Wizard, {
        header: /*#__PURE__*/ React.createElement(Breadcrumbs, null, membershipStepper.map(function(stepName, index) {
            return /*#__PURE__*/ React.createElement(BreadcrumbStep, {
                name: stepName,
                key: index,
                stepIndex: index,
                stepLabel: index + 1
            });
        }))
    }, /*#__PURE__*/ React.createElement(MembershipStep, {
        includeNoMembership: false,
        membershipPriceId: membershipPriceId,
        onMembershipChange: function(membershipPriceIdValue) {
            var _membershipPriceIdValue_target, _membershipPriceIdValue_target1;
            return dispatch(setMembershipPriceId(((_membershipPriceIdValue_target = membershipPriceIdValue.target) === null || _membershipPriceIdValue_target === void 0 ? void 0 : _membershipPriceIdValue_target.value) ? (_membershipPriceIdValue_target1 = membershipPriceIdValue.target) === null || _membershipPriceIdValue_target1 === void 0 ? void 0 : _membershipPriceIdValue_target1.value : membershipPriceIdValue));
        },
        nextButtonProps: {
            onClick: function(nextStep) {
                if (isStaff(currentUser.role)) {
                    dispatch(alertWarning(text('disabledPaymentScreenForSupportAlert'), {}));
                } else {
                    nextStep();
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(MembershipManagementPaymentStep, {
        isAssignedPayment: isAssignedPayment(selectedPayMode),
        nextButtonProps: {
            label: isAssignedPayment(selectedPayMode) ? text('sendRequest') : text('continueToConfirm')
        },
        onSubmit: function(param) {
            var payerEmail = param.payerEmail, payerName = param.payerName, message = param.message;
            return handleSendToPayer(payerName, payerEmail, message);
        }
    }), /*#__PURE__*/ React.createElement(ConfirmationStep, {
        onSubmit: handleSubmit
    })));
};
var MembershipManagementWizardWithStripe = function(props) {
    return /*#__PURE__*/ React.createElement(StripeElements, null, /*#__PURE__*/ React.createElement(MembershipManagementWizard, props));
};
export default MembershipManagementWizardWithStripe;
